<template>
  <div :class="_.search">
    <!-- 搜索框区域 -->
    <div :class="_.box">
      <x-icon name="search" :class="_.icon" />
      <!-- 输入框 -->
      <input
        v-model.trim="keyword"
        type="text"
        :placeholder="placeholder"
        :class="_.input"
      />

      <x-icon
        v-if="keyword"
        name="close-circle"
        :class="_.clear"
        @click.native.prevent.stop="handleClearClick"
      />
    </div>

    <!-- 搜索按钮 -->
    <div :class="_.btn" @click="handleSearch">搜索</div>
  </div>
</template>

<script>
  import Vue from 'vue'

  export default Vue.extend({
    name: 'SearchHeader',

    props: {
      // 占位符文本
      placeholder: {
        type: String,
        default: '请输入搜索关键词',
      },
    },

    data: () => ({
      keyword: '',
    }),

    methods: {
      // 处理搜索
      handleSearch() {
        this.$emit('search', this.keyword)
      },

      // 清除搜索关键词
      handleClearClick() {
        this.keyword = ''
        this.$emit('search', '')
      },
    },
  })
</script>

<style lang="scss" module>
  .search {
    flex: 1;
    display: flex;
    align-items: center;
    padding: 4px 0 4px 6px;

    .box {
      flex: 1;
      display: flex;
      align-items: center;
      min-height: 34px;
      padding: 0 16px;
      background-color: #f5f5f5;
      border-radius: 27px;
      margin-right: 12px;

      .icon {
        flex-shrink: 0;
        font-size: 16px;
        color: #b2b2b2;
        margin-right: 8px;
      }

      .input {
        flex: 1;
        font-size: 14px;
        color: #333333;
        appearance: none;
        box-shadow: none;
        border: none;
        border-radius: 0;
        outline: none;
        background-color: transparent;

        /* clears the 'X' from Internet Explorer */
        &::-ms-clear,
        &::-ms-reveal {
          display: none;
          width: 0;
          height: 0;
        }

        /* clears the 'X' from Chrome */
        &::-webkit-search-decoration,
        &::-webkit-search-cancel-button,
        &::-webkit-search-results-button,
        &::-webkit-search-results-decoration {
          display: none;
        }

        &::placeholder {
          color: #888888;
        }
      }

      .clear {
        flex-shrink: 0;
        font-size: 18px;
        color: #ccc;
        margin-left: 8px;
      }
    }

    .btn {
      display: flex;
      align-items: center;
      justify-content: center;
      min-width: 54px;
      height: 28px;
      background: linear-gradient(131deg, #ffbb43 0%, #ff8311 100%);
      color: #fff;
      border-radius: 27px;
      font-size: 14px;
    }
  }
</style>
